// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showToolbar {
  --background: var(--background-gradient);
  --color: white;
}
.showToolbar--orange {
  --background: var(--orange-color);
}

.showApp__mobile .outletContent {
  position: absolute;
  top: 0;
}
.showApp__web {
  height: 100vh;
  display: flex;
  flex-direction: row;
}
.showApp .content {
  width: 100%;
  height: 100%;
}
.showApp .headerButton {
  outline: none !important;
}
.showApp .headerIcon {
  min-height: 24px;
  min-width: 24px;
  max-height: 24px;
  max-width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/shared/show/show.component.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,cAAA;AACF;AACE;EACE,iCAAA;AACJ;;AAKI;EACE,kBAAA;EACA,MAAA;AAFN;AAME;EACE,aAAA;EACA,aAAA;EACA,mBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;AALJ;AAQE;EACE,wBAAA;AANJ;AASE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAPJ","sourcesContent":[".showToolbar {\n  --background: var(--background-gradient);\n  --color: white;\n\n  &--orange {\n    --background: var(--orange-color);\n  }\n}\n\n.showApp {\n  &__mobile {\n    .outletContent {\n      position: absolute;\n      top: 0;\n    }\n  }\n\n  &__web {\n    height: 100vh;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .content {\n    width: 100%;\n    height: 100%;\n  }\n\n  .headerButton {\n    outline: none !important;\n  }\n\n  .headerIcon {\n    min-height: 24px;\n    min-width: 24px;\n    max-height: 24px;\n    max-width: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
